<template>
    <div class="container">
        <div class="logo">
            <img alt="Vue logo" class="logo" src="../../../../assets/Img/Mocerowhitelogo.svg"/>
        </div>

        <div class="content">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam vel lorem ac ligula fringilla .</p>
        </div>
        <div class="dosecount">
            <div class="con">
                <p>72</p>
                <p class="def">Doses</p>
            </div>
        </div>
        <div class="swipe">
            <p>Slide up</p>
        </div>
    </div>    

    
    </template>
        
        <script lang="ts">
        import {defineComponent} from 'vue'
        export default defineComponent({
            
            setup(){
                return{
                    
                }
            }
        
        })
        </script>
        
        <style scoped lang="scss">
        .container{
            width: 100%;
            height: 100vh;
            background-color: #05096c;
            .content p{
               color:white;
               font-size:30px;
               font-weight: 700;
               text-align:left;
               padding-left:50px;
            }
            .logo{
                width:200px;
                padding:20px;
            }
            .dosecount{
                color:white;
                .con{
                    font-size:100px;
                    font-weight:700;
                    text-align: left;
                    padding-left:50px;

                    p{
                        margin-block-start: 0em !important;
                        margin-bottom:0px;
                    }
                    .def{
                        font-size:40px;
                        margin:0px;
                        margin-left: 10px;
                        font-weight:100;
                    }
                }
                .con1{
                    font-size:70px;
                }
            }
            .swipe{
                color:white;
                text-align: center;
                margin-top:80px;
            }
        }
        
        </style>